import { restApi } from '../../../services/api';

const PATH = '/invites';

export const myNetworkInvitesReceivedRepository = () => {
  const getInvitesSent = () => restApi.get(`${PATH}?type=RECEIVED`);
  const accept = (id: string): any => restApi.patch(`${PATH}/${id}/accept`);
  const ignore = (id: string): any => restApi.patch(`${PATH}/${id}/ignore`);

  return {
    getInvitesSent,
    accept,
    ignore,
  };
};
